import {
  OPEN_NEW_INTEGRATION_DIALOG,
  CLOSE_NEW_INTEGRATION_DIALOG,
  SET_INTEGRATION_MUTATING_FLAG,
  CREATE_NEW_INTEGRATION,
  SET_INTEGRATIONS,
  FETCH_INTEGRATIONS,
  ADD_INTEGRATION,
  DELETE_INTEGRATION,
  REMOVE_DELETED_INTEGRATION,
  UPDATE_INTEGRATION,
  UPDATE_UPDATED_INTEGRATION,
  SET_OPEN_SHARE_INTEGRATION_DIALOG,
  SET_OPEN_UNSHARE_INTEGRATION_DIALOG,
  SET_OPEN_SHARE_UNSHARE_DIALOG,
  FETCH_OWNED_SHARED_INTEGRATIONS,
  SET_OWNED_SHARED_INTEGRATIONS,
  FETCH_SHARED_INTEGRATIONS_SHARED,
  SET_SHARED_INTEGRATIONS_SHARED,
  FETCH_SHARED_INTEGRATIONS,
  SET_SHARED_INTEGRATIONS,
  UPDATE_SHARED_INTEGRATION
} from "redux/constants/portal";

export const openNewIntegrationDialog = () => ({
  type: OPEN_NEW_INTEGRATION_DIALOG,
});

export const closeNewIntegrationDialog = () => ({
  type: CLOSE_NEW_INTEGRATION_DIALOG,
});

export const setIntegrationMutatingFlag = (payload) => ({
  type: SET_INTEGRATION_MUTATING_FLAG,
  payload,
});

export const createNewIntegration = (payload) => ({
  type: CREATE_NEW_INTEGRATION,
  payload,
});

export const setIntegrations = (payload) => ({
  type: SET_INTEGRATIONS,
  payload,
});

export const fetchIntegrations = (payload) => ({
  type: FETCH_INTEGRATIONS,
  payload,
});

export const addIntegration = (payload) => ({
  type: ADD_INTEGRATION,
  payload,
});

export const deleteIntegration = (payload) => ({
  type: DELETE_INTEGRATION,
  payload,
});

export const removeDeletedIntegration = (payload) => ({
  type: REMOVE_DELETED_INTEGRATION,
  payload,
});

export const updateIntegration = (payload) => ({
  type: UPDATE_INTEGRATION,
  payload,
});

export const updateUpdatedIntegration = (payload) => ({
  type: UPDATE_UPDATED_INTEGRATION,
  payload,
});

export const updateSharedIntegration = (payload) => ({
  type: UPDATE_SHARED_INTEGRATION,
  payload,
});

export const setOpenShareIntegrationDialog = (payload) => ({
  type: SET_OPEN_SHARE_INTEGRATION_DIALOG,
  payload,
});

export const setOpenUnshareIntegrationDialog = (payload) => ({
  type: SET_OPEN_UNSHARE_INTEGRATION_DIALOG,
  payload,
});

export const setOpenShareUnshareIntegrationDialog = (payload) => ({
  type: SET_OPEN_SHARE_UNSHARE_DIALOG,
  payload,
});

export const fetchOwnedSharedIntegrations = (auth0_id) => ({
  type: FETCH_OWNED_SHARED_INTEGRATIONS,
  payload: { auth0_id },
});

export const setOwnedSharedIntegrations = (payload) => ({
  type: SET_OWNED_SHARED_INTEGRATIONS,
  payload,
});

export const fetchSharedIntegrationsShared = (auth0_id) => ({
  type: FETCH_SHARED_INTEGRATIONS_SHARED,
  payload: { auth0_id },
});

export const setSharedIntegrationsShared = (payload) => ({
  type: SET_SHARED_INTEGRATIONS_SHARED,
  payload,
});

export const fetchSharedIntegrations = (tenant_id) => ({
  type: FETCH_SHARED_INTEGRATIONS,
  payload: { tenant_id },
});

export const setSharedIntegrations = (payload) => ({
  type: SET_SHARED_INTEGRATIONS,
  payload,
});
